import { validatePolish } from 'validate-polish';
import { AppFormItem, AppFormItemProps, AppMaskedInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { peselNumberRegExp } from 'consts/regexps';
import { childrenTexts } from 'consts/text';
import { createFieldValidationRules } from 'utils/formValidationHelpers';

const TEST_PESEL = '11111111111';

export const PeselInputElement = ({ disabled, ...restProps }: AppFormItemProps) => (
    <AppFormItem
        label={childrenTexts.childForm.personalData.pesel}
        name={formFields.peselNumber}
        rules={createFieldValidationRules('pesel', {
            required: true,
            pattern: peselNumberRegExp,
            patternErrorMessage: 'Niepoprawny numer PESEL',
            customValidator: (value) =>
                // for test purposes
                value === TEST_PESEL || validatePolish.pesel(value as string),
            customErrorMessage: 'Niepoprawny numer PESEL',
        })}
        disabled={disabled}
        accessibilityLabel="Pole PESEL"
        {...restProps}
    >
        <AppMaskedInput
            mask="00000000000"
            disabled={disabled}
            autoComplete="off"
            placeholder="Podaj numer PESEL"
        />
    </AppFormItem>
);
